import apiClient from '../../../shared/api/client';

export const getPacienteInformeById = async (pacienteId) => {
  const response = await apiClient.get(`/pacientes/informes/${pacienteId}`);
  return response?.data;
};

export const getCapacidades = async () => {
  const response = await apiClient.get('/capacidad');
  return response?.data;
};

export const getCapacidadById = async (capacidadId) => {
  const response = await apiClient.get(`/capacidad/${capacidadId}`);
  return response?.data;
};

export const createCapacidad = async ({ pacienteId, userId, payload }) => {
  const response = await apiClient.post(`/capacidad/${pacienteId}/${userId}`, payload);
  return response?.data;
};

export const updateCapacidad = async ({ codigoInforme, payload }) => {
  const response = await apiClient.put(`/capacidad/${codigoInforme}`, payload);
  return response?.data;
};

export const deleteCapacidad = async (codigoInforme) => {
  const response = await apiClient.delete(`/capacidad/${codigoInforme}`);
  return response?.data;
};
